import {createStore} from "vuex";

const debug = process.env.NODE_ENV !== 'production'

export default createStore({
    modules: {
    },
    state: {
        name: null,
        locale: 'nl_BE',
        idlanguagecode : 2,
        fingerprint: null,
        bearerToken: null,
        maintenance: false,
        langList: [],
        idParticipationType: null,
        currentPage: null,
        spinnerVisible: false,
        isGdprVisible: true,
        shouldSendEmail: false,
        waterMarkIsVisible: false,
    },

    
    /* Mutations are to update the state */
    /* ONE action by mutation */
    /* methodName (state, payload) {…} */
    /* mutations must be synchronous */
    mutations: {
        setName (state, name) {
            state.name = name;
        },
        clearName (state) {
            state.name = null;
        },
        SET_LOCALE (state, locale) {
            state.locale = locale;
        },
        SET_FINGERPRINT (state, fingerprint) {
            state.fingerprint = fingerprint;
        },
        SET_BEARER_TOKEN(state, bearerToken) {
            state.bearerToken = bearerToken;
        },
        SET_MAINTENANCE(state, value) {
            state.maintenance = value;
        },
        setIdLanguageCode (state, id){
            state.idlanguagecode = id;
        },
        fillLangList (state, list) {
            state.langList = list;
        },
        SET_IDPARTICIPATIONTYPE (state, idParticipationType){
            state.idParticipationType = idParticipationType;
        },
        setSpinnerState(state, bool){
            state.spinnerVisible = bool;
        },
        setGdprVisibility(state, bool){
            state.isGdprVisible = bool;
        },
        setShouldSendEmail(state, bool){
            state.shouldSendEmail = bool;
        },
        SET_CURRENT_PAGE(state, str){
            state.currentPage = str;
        },
        SET_WATERMARK_VISIBILITY(state, bool){
            state.waterMarkIsVisible = bool;
        },
    },





    /* Actions can be asynchronous */
    /* commit takes the name of the mutation it triggers */
    actions: {
        setName (context, name) {
            context.commit('setName', name);
        },
        clearName (context) {
            context.commit('clearName');
        },
        setLocale (context, payload) {
            context.commit('SET_LOCALE', payload.locale);
        },
        setFingerprint (context, payload) {
            context.commit('SET_FINGERPRINT', payload.fingerprint);
        },
        setBearerToken(context, payload) {
            context.commit("SET_BEARER_TOKEN", payload.bearerToken);
        },
        setMaintenance(context, payload) {
            context.commit("SET_MAINTENANCE", payload)
        },
        setIdLanguageCode (context, id){
            context.commit('setIdLanguageCode', id);
        },
        setLangList(context, payload){
            context.commit('fillLangList', payload);
        },
        setIdParticipationType (context, payload) {
            context.commit('SET_IDPARTICIPATIONTYPE', payload);
        },
        setSpinner(context, payload){
            context.commit('setSpinnerState', payload);
        },
        setShouldSendEmail(context, payload){
            context.commit('setShouldSendEmail', payload);
        },
        setGdprVisible(context, payload){
            context.commit('setGdprVisibility', payload);
        },
        setCurrentPage(context, payload){
            context.commit('SET_CURRENT_PAGE', payload);
        },
        setWatermarkVisibility(context, payload){
            context.commit('SET_WATERMARK_VISIBILITY', payload);
        },
    },






    getters: {
        isSpinnerSpinning: state => {
            return state.spinnerVisible;
        },
        getName: (state) => {
            return state.name;
        },
        getLang: (state) => {
            return state.locale.slice(0,2);
        },
        getLocale: (state) => {
            return state.locale;
        },
        getFingerprint: (state) => {
            return state.fingerprint;
        },
        getBearerToken: (state) => {
            return state.bearerToken;
        },
        getIdLanguageCode: (state) => {
            return state.idlanguagecode;
        },
        getMaintenance: (state) => {
            return state.maintenance;
        },
        getLangList: (state) => {
            return state.langList;
        },
        getIdParticipationType: (state) => {
            return state.idParticipationType;
        },
        getSendingMailRequested: (state) => {
            return state.shouldSendEmail;
        },
        getGdprVisibility: (state) => {
            return state.isGdprVisible;
        },
        getCurrentPage: state => {
            return state.currentPage;
        },
        getWatermarkVisibility: state => {
            return state.waterMarkIsVisible;
        },
    },
    strict: debug,
});
